// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class CountryService extends BaseService {


  // Verify user credentials on server to get token
  get(): Observable<any> {

    return this.http
      .get<any>(this.basePath + '/v1/countries')
      .pipe(
        catchError(this.handleError)
      );
  }

}
